export const PRODUCTS = [
    {
        "id": 1,
        "name": "Product-1",
        "sku": "product-sku-1",
        "description": "SKU product 1 description",
        "price": 500.00,
        "tax_code": "ABCDEF",
        "license_type": "Perpetual"
    },
    {
        "id": 1,
        "name": "Product-2",
        "sku": "product-sku-2",
        "description": "SKU product 2 description",
        "price": 100.00,
        "tax_code": "GHIJKL",
        "license_type": "Yearly renewal"
    }
]

export const PRODUCT_FIELDS = [
    { name: 'product', label: 'Product', rules: [{ required: true, message: 'Please input the Product' }] },
    { name: 'name', label: 'Name', rules: [{ required: true, message: 'Please input the Name!' }] },
    { name: 'sku', label: 'SKU' },
    { name: 'description', label: 'Description', rules: [{ required: true, message: 'Please input the Description!' }] },
    { name: 'version', label: 'Version'},
    { name: 'price', label: 'Original Price', rules: [
        { required: true, message: 'Please input the Original price!' }
    ]},
    { name: 'license_type', label: 'License Type', rules: [{ required: true, message: 'Please input the License Type!' }] },
    { name: 'is_bundled', label: 'Bundle?', rules: [{ required: true, message: 'Please input the License Type!' }] },
    { name: 'is_credit_memo', label: 'Credit Memo?', rules: [{ required: true, message: 'Please choose if it is Credit Memo!' }] },
    { name: 'is_taxable', label: 'Taxable?', rules: [{ required: true, message: 'Please choose if it is taxable!' }] },
];

export const LICENSE_TYPES = [
    {
        label: 'PaaS',
        value: 1,
    },
    {
        label: 'Perpetual',
        value: 2,
    },
    {
        label: 'SaaS',
        value: 3,
    },
    {
        label: 'Services',
        value: 4,
    },
];

export const BUNDLE_TYPES = [
    {
        label: 'Yes',
        value: true,
    },
    {
        label: 'No',
        value: false,
    },
];

export const DEFAULT_SERVER_STATUS = {success: false, code: null, message: null};